const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    
    window.location.hostname === '[::1]' ||
    
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export function register(config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      
      if (config && config.onFailure) {
        config.onFailure();
      }

      return;
    }

    navigator.serviceWorker.getRegistrations().then(function(registrations) {
      if (registrations.length) {
        for (let registration of registrations) {
          if (registration.active) {
            if (registration.active.scriptURL.includes('service-worker.js')) {
              registration.unregister();
            }
          }
        }
      }
    });

    if (document.readState === 'complete') {
      initSW(config);
    } else {
      window.addEventListener('load', () => {
        initSW(config);
      });
    }
  } else if ('isSecureContext' in window && !window.isSecureContext) {
    if (config && config.onFailure) {
      config.onFailure('You are not securely connected. No offline support.');
    }
  } else if (!('serviceWorker' in navigator)) {
    if (config && config.onFailure) {
      config.onFailure('Your browser does not have offline support.');
    }
  }
}

function initSW(config) {
  const swUrl = `${process.env.PUBLIC_URL}/sw.js`;

  if (isLocalhost) {
    checkValidServiceWorker(swUrl, config);

    navigator.serviceWorker.ready.then(() => {
      console.log(
        'This web app is being served cache-first by a service ' +
          'worker. To learn more, visit http://bit.ly/CRA-PWA'
      );
    });
  } else {
    registerValidSW(swUrl, config);
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              console.log(
                'New content is available and will be used when all ' +
                  'tabs for this page are closed. See http://bit.ly/CRA-PWA.'
              );
              
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              console.log('Content is cached for offline use.');
              
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  
  fetch(swUrl)
    .then((response) => {
      
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log(
        'No internet connection found. App is running in offline mode.'
      );
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
}
